import {IWrapper} from '../types';
import {IPortalConfig, PortalConfigResponse} from '../types/endpoints';

/**
 * PortalConfigEndpoint class implements IPortalConfig interface.
 */
class PortalConfigEndpoint implements IPortalConfig {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param {IWrapper} wrapper - The wrapper instance.
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Get portal config
   * @returns {Promise<PortalConfigResponse>} - The portal configuration.
   */
  public getPortalConfig(): Promise<PortalConfigResponse> {
    return this.wrapper.get<PortalConfigResponse>('/v2/configurations');
  }
}

export default PortalConfigEndpoint;
